import { OrderItemWrapper } from '@/components/modals/SubmitOrder/types';

import { Props } from './components/ServicesCard/types';

export const completeServicesCard: Props['services'] = {
  title: 'Complete Energy Services',
  list: [
    'Design (plan set)',
    'Permit',
    'Electrical installation; inspection',
    'Utility interconnection',
    'Project coordination',
    'Solar Max warranty eligible',
  ],
};

export const designServicesCard: Props['services'] = {
  title: 'Design Services',
  list: ['Design (reduced plan set)', 'Solar Max Warranty eligible'],
};

export const isProductAvailable = (orderItems: OrderItemWrapper): boolean => {
  return Boolean(orderItems.priceBookEntry.isProductAvailable);
};
